export type DeepPartial<Type> = Type extends object
  ? { [Property in keyof Type]?: DeepPartial<Type[Property]> }
  : Type
export const isString = (x: unknown): x is string => typeof x === 'string'
export const isStringArray = (x: unknown): x is string[] =>
  Array.isArray(x) && x.every((v): v is string => typeof v === 'string')